/**
 * Значения, приходящие на этапе сборки.
 *
 * ПРАВИЛО, РАДИ КОТОРОГО ФАЙЛ СУЩЕСТВУЕТ: в боевой сборке не может быть
 * localhost. Это не предосторожность, а уже случившийся класс дефекта - на
 * сервере `APP_URL` с дефолтом на localhost тихо уезжал в список разрешённых
 * источников боевого CORS, и заметили это только при подготовке образа.
 *
 * Здесь дефолт на localhost остаётся, но работает ТОЛЬКО в разработке.
 * Сборка в режиме production без `VITE_API_URL` падает - см. vite.config.ts.
 */

/** Адрес api. В разработке - локальный сервер, в сборке - из переменной. */
export const API_URL: string = import.meta.env['VITE_API_URL'] ?? 'http://localhost:3003';

/**
 * Публичный ключ Turnstile.
 *
 * НЕ СЕКРЕТ: он и должен быть виден в HTML - виджет рисуется в браузере
 * пользователя. Секретный ключ (`TURNSTILE_SECRET_KEY`) живёт только в
 * окружении сервера и во фронтенд не попадает ни при каких условиях: Vite
 * подставляет в сборку лишь переменные с приставкой `VITE_`, и секрет такой
 * приставки не имеет.
 *
 * Пусто - виджет не рисуется. Это состояние разработки: сервер без секретного
 * ключа проверку пропускает, и требовать ключи Cloudflare для `pnpm dev` было
 * бы требованием провижининга ради локального запуска.
 */
export const TURNSTILE_SITE_KEY: string | undefined =
  import.meta.env['VITE_TURNSTILE_SITE_KEY'] || undefined;

/** Публичный сайт: бренд в шапке auth ведёт на него. */
export const LANDING_URL = 'https://efira.live';
